var map = {
	"./california.json": 83750,
	"./climbing.json": 72827,
	"./incredible-hulk.json": 37488,
	"./morocco.json": 47142,
	"./people.json": 52907,
	"./places.json": 66712,
	"./turkey.json": 92534,
	"./utah.json": 53680,
	"./winter.json": 21285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90793;